module.exports = __webpack_public_path__ + "media/images/flags/1x1/cuw-68cd0625f3b151396951555f0e0d51dd.svg";